import Tooltip from '@material-ui/core/Tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AddColorPopUp from '@components/colors/AddColorPopUp';
import SelectSizeCategory from '@components/SelectSizeCategory';

import OrderCancelBottomBar from '@features/order-cancel/OrderCancelBottomBar';
import SizeCategoryModal from '@features/design/components/SizeCategoryModal';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { fetchEnumFilter, fetchSizeForProducts } from '@store/design/action';
import { getEnumFilter, getOrderDetailsInfo } from '@store/reducers';

import { increaseSizeCategorySequence } from '@services/measurementService';

import {
	convertNumberToUSFormat,
	findHeadingMaxLength,
	isValidInput,
	packTag,
	parseQuoteName,
	printApiError,
	renderPantoneTypeColorsVertically,
	renderSetImages,
	renderSwatchTypeColorsVertically,
	setTag,
	STATIC_SET_CONSTANTS,
	validateFloatNumber,
	validateNumber
} from '@utils/Util';

import { PANTONE_OR_HEX_CODE, SWATCH } from '@/constants/constant';

const OrderStyleItem = ({
	onSetOrderStyles,
	stylesData,
	errorInfo,
	onUpdateDesignInfo,
	isDesignEditable,
	onUpdateColorSize,
	onGetDesignWiseToalPrice,
	onGetDesignWiseToalQuantity,
	isFromCreateOrder,
	isUpdatingOrder,
	removeStyle,
	readOnly = false,
	orderCancelInfo,
	isShowStyleStatus = false,
	hideStatusType
}) => {
	const [isAddSize, setIsAddSize] = useState(false);
	const [addDesignIndex, setAddDesignIndex] = useState('');
	const [selectedColorList, setSelectedColorList] = useState([]);
	const [editableIndex, setEditableIndex] = useState('');
	const [errorDesign, setErrorDesign] = useState({});
	const [designIdList, setDesignIdList] = useState([]);
	const [productWiseColorIds, setProductWiseColorIds] = useState({});
	const [removedColorIds, setRemovedColorIds] = useState([]);
	const [removedSizes, setRemovedSizes] = useState([]);
	const [isShowModal, setIsShowModal] = useState(false);
	const [selectedRFQIds, setSelectedRFQIds] = useState([]);

	const orderDetailsInfo = useSelector(getOrderDetailsInfo);

	const handleRFQIds = (rfqId) => {
		if (selectedRFQIds.includes(rfqId)) {
			let tmpList = selectedRFQIds.filter((item) => item !== rfqId);
			setSelectedRFQIds(tmpList);
		} else {
			setSelectedRFQIds((prev) => [...prev, rfqId]);
		}
	};

	const dispatch = useDispatch();
	let colorRef = useRef(null);
	let sizeRef = useRef(null);
	let prevDataRef = useRef(null);
	let allQuotation = useSelector(getEnumFilter);

	useEffect(() => {
		dispatch(fetchEnumFilter('info.nitex.app.rfq.POSegmentationType')).finally(() => {});
		document.addEventListener('click', onClickOutside, { capture: true });
		return () => {
			document.removeEventListener('click', onClickOutside);
		};
	}, [dispatch]);

	useEffect(() => {
		if (stylesData) {
			let ids = stylesData.map((item) => item.productId);
			setDesignIdList(ids);
			if (!isFromCreateOrder) {
				let quotationColorIds = [];
				let productColorIds = [];
				stylesData
					.map((styleItem) => styleItem.colorWiseSizeQuantityPairList)
					.forEach((colorItem) => {
						quotationColorIds.push(...colorItem.map((singleItem) => singleItem.id));
					});
				stylesData
					.map((styleItem) => styleItem?.productColorIds)
					.forEach((colorIds) => productColorIds.push(...colorIds));

				let removedColorIds = productColorIds
					.filter((id) => !quotationColorIds.includes(id))
					.map((id) => parseInt(id));
				setRemovedColorIds(removedColorIds);
			} else {
				let productWiseColorIds = {};
				stylesData.map((styleItem) => {
					productWiseColorIds[styleItem.productId] = styleItem.colorWiseSizeQuantityPairList?.map(
						(colorId) => colorId.id
					);
				});
				setProductWiseColorIds(productWiseColorIds);
			}
		}
	}, [stylesData]);

	const onClickOutside = (event) => {
		if (colorRef.current && !colorRef.current.contains(event.target)) {
			onClosePopups();
		}
		if (sizeRef.current && !sizeRef.current.contains(event.target)) {
			onClosePopups();
		}
	};

	const onCloseViewModal = () => {
		dispatch(clearDesignViewModalInfo({}));
	};

	const onClosePopups = () => {
		setAddDesignIndex('');
		setIsAddSize(false);
	};

	const getItemTotal = (items) => {
		return items.reduce((total, item) => {
			return total + getTotal(item.sizeQuantityPairList);
		}, 0);
	};

	const onEditChange = (e, index, quoteIndex, inputIndex) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData.colorWiseSizeQuantityPairList[index].sizeQuantityPairList[inputIndex].quantity = isNaN(
			parseInt(value)
		)
			? 0
			: value === ''
				? 0
				: parseInt(value);
		orderData.total = getItemTotal(orderData.colorWiseSizeQuantityPairList);
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const getTotal = (items) => {
		return items.reduce((total, pair) => {
			if (pair.quantity) {
				return total + parseInt(pair.quantity);
			}
			return total;
		}, 0);
	};

	const getSizeWiseQuantity = (item, orderData, itemId, type) => {
		let newColorWiseSize = {};
		if (type === SWATCH) {
			newColorWiseSize = {
				...item,
				representedBy: SWATCH,
				id: itemId
			};
		} else {
			newColorWiseSize = {
				...item,
				name: item?.name,
				id: itemId
			};
		}
		let sizes = [];
		if (orderData.colorWiseSizeQuantityPairList?.length > 0) {
			sizes = orderData.colorWiseSizeQuantityPairList[0]?.sizeQuantityPairList.map((item) => {
				return {
					...item,
					quantity: 0
				};
			});
		} else if (orderData.sizeQuantityPairList?.length > 0) {
			sizes = orderData.sizeQuantityPairList?.map((item) => {
				return {
					...item,
					quantity: 0
				};
			});
		}
		newColorWiseSize.sizeQuantityPairList = sizes;
		return newColorWiseSize;
	};

	const onAddNewColors = (item) => {
		const newData = [...stylesData];
		const orderData = newData[addDesignIndex];
		if (item.representedBy === PANTONE_OR_HEX_CODE) {
			const newColorWiseData = getSizeWiseQuantity(item, orderData, item.id, PANTONE_OR_HEX_CODE);
			orderData.colorWiseSizeQuantityPairList = [
				...orderData.colorWiseSizeQuantityPairList,
				newColorWiseData
			];
			newData[addDesignIndex] = orderData;
			onSetOrderStyles(newData);
			setSelectedColorList([...selectedColorList, item]);
		} else {
			const newColorWiseData = getSizeWiseQuantity(item, orderData, item.id, SWATCH);
			orderData.colorWiseSizeQuantityPairList = [
				...orderData.colorWiseSizeQuantityPairList,
				newColorWiseData
			];
			newData[addDesignIndex] = orderData;
			onSetOrderStyles(newData);
			setSelectedColorList([...selectedColorList, item]);
		}
	};

	const renderAddColor = (productId, selectedColors) => {
		if (!readOnly) {
			return (
				<AddColorPopUp
					selectedColors={selectedColors}
					onAddNewColors={onAddNewColors}
					productId={productId}
					showRemovedColors={true}
					removedColorIds={removedColorIds}
					setRemovedColorIds={setRemovedColorIds}
				/>
			);
		}
	};

	const renderAddSize = (item) => {
		if (isAddSize) {
			return (
				<SelectSizeCategory
					productId={item.productId}
					selectedItem={item}
					setIsAddSize={setIsAddSize}
					onAddSize={onAddSize}
					onRemoveSize={onRemoveSize}
					colorIds={productWiseColorIds[item.productId]}
					onAddNewSize={onAddNewSize}
					isFromCreateOrder={isFromCreateOrder}
				/>
			);
		}
	};

	const onAddColorModal = (index) => {
		setAddDesignIndex(index);
	};

	const onAddSize = async (item, payload) => {
		if (item) {
			try {
				const newData = [...stylesData];
				const selectedDesign = newData[addDesignIndex];
				if (payload !== undefined) {
					if (!([payload.sizeCategoryId] in selectedDesign.sizeCategorySequenceMap)) {
						dispatch(openLoader());
						const data = await increaseSizeCategorySequence(
							payload.productId,
							payload.sizeCategoryId,
							'PP_SAMPLE'
						);
						selectedDesign.sizeCategorySequenceMap = data;
						dispatch(closeLoader());
					}

					let prevColorWiseSizes = selectedDesign.colorWiseSizeQuantityPairList;
					let newColorWiseSizes = payload.colorWiseSizeQuantityPairList;
					let colorWiseSizeObj = {};
					for (let prevColor of prevColorWiseSizes) {
						for (let prevSize of prevColor.sizeQuantityPairList) {
							colorWiseSizeObj[`${prevColor.id}_${prevSize.id}`] = prevSize.quantity;
						}
					}

					for (let newColor of newColorWiseSizes) {
						for (let newSize of newColor.sizeQuantityPairList) {
							newSize.quantity = colorWiseSizeObj[`${newColor.id}_${newSize.id}`] || 0;
						}
					}
					// selectedDesign.allSizeResponseList = payload.allSizeResponseList;
					selectedDesign.sizeCategoryResponse = payload.sizeCategoryResponse;
					selectedDesign.colorWiseSizeQuantityPairList = newColorWiseSizes;
					selectedDesign.sizeQuantityPairList = payload.sizeQuantityPairList;
					selectedDesign.sizeCategoryId = payload.sizeCategoryId;
				} else {
					selectedDesign.colorWiseSizeQuantityPairList.map((value) => {
						value.sizeQuantityPairList = [
							...value.sizeQuantityPairList,
							{ label: item.value, id: item.id, quantity: 0 }
						];
					});
				}
				onSetOrderStyles(newData);
				onClosePopups();
			} catch (e) {
				printApiError(e);
				dispatch(closeLoader());
			}
		}
	};

	const onRemoveSize = (sizeId) => {
		let newData = JSON.parse(JSON.stringify(stylesData));
		newData[addDesignIndex].colorWiseSizeQuantityPairList.map((value) => {
			value.sizeQuantityPairList = value.sizeQuantityPairList.filter((item) => item.id !== sizeId);
			return value;
		});
		onSetOrderStyles(newData);
	};

	const onAddSizeModal = (index) => {
		if (readOnly) return;
		const newData = [...stylesData];
		const design = newData[index];
		dispatch(fetchSizeForProducts(design.productId));
		setIsAddSize(true);
		setAddDesignIndex(index);
	};

	const onChangeQuotationType = (item, quoteIndex) => {
		const newData = [...stylesData];
		const selectedDesign = newData[quoteIndex];
		selectedDesign['buyerQuotationType'] = item.constant;
		onSetOrderStyles(newData);
	};

	const onChangePriceType = (type, quoteIndex) => {
		const newData = [...stylesData];
		const selectedDesign = newData[quoteIndex];
		selectedDesign['priceType'] = type;
		onSetOrderStyles(newData);
		if (isDesignEditable) {
			let isUpdateColorWisePrice;
			if (type === 'CIF' || type === 'FOB') {
				isUpdateColorWisePrice = true;
			}
			onUpdateColorSize(selectedDesign, quoteIndex, isUpdateColorWisePrice);
		}
	};

	const onChangeColorWise = (e, quoteIndex, colorId) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData['colorWiseBuyerPrice'] = {
			...orderData['colorWiseBuyerPrice'],
			[colorId]: parseFloat(value)
		};
		orderData['sizeWiseBuyerPrice'] = {};
		orderData['designWiseBuyerPrice'] = null;
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onChangeSizeWise = (e, quoteIndex, sizeId) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData['sizeWiseBuyerPrice'] = { ...orderData['sizeWiseBuyerPrice'], [sizeId]: parseFloat(value) };
		orderData['colorWiseBuyerPrice'] = {};
		orderData['designWiseBuyerPrice'] = null;
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onChangeDesignWise = (e, quoteIndex) => {
		let { value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData['designWiseBuyerPrice'] = parseFloat(value);
		orderData['sizeWiseBuyerPrice'] = {};
		orderData['colorWiseBuyerPrice'] = {};
		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onUpdateSizeColorWise = (item, quoteIndex, isTriggerFromUnitPrice) => {
		prevDataRef.current = null;
		if (isDesignEditable) {
			onUpdateColorSize(item, quoteIndex, isTriggerFromUnitPrice);
		}
	};

	const getColorWisePrice = (colorWisePrices, id) => {
		if (colorWisePrices && colorWisePrices[id]) {
			return colorWisePrices[id];
		}
		return null;
	};

	const getSizeWisePrice = (sizeWisePrices, id) => {
		if (sizeWisePrices && sizeWisePrices[id]) {
			return sizeWisePrices[id];
		}
		return null;
	};

	const getTableClassName = (quoteIndex) => {
		let className = 'category-wise-table ';
		if (stylesData[quoteIndex]?.buyerQuotationType === 'COLORWISE') return className + 'color-wise-table';
		else if (stylesData[quoteIndex]?.buyerQuotationType === 'SIZEWISE')
			return className + 'sizewise-wise-table';
		else return className + 'design-wise-table';
	};

	const removeSizeColumn = async (item, sizeId, quoteIndex) => {
		dispatch(openLoader());
		try {
			let cloneStyles = JSON.parse(JSON.stringify(stylesData));
			if (item.colorWiseSizeQuantityPairList.length > 0) {
				cloneStyles[quoteIndex].colorWiseSizeQuantityPairList = await cloneStyles[
					quoteIndex
				].colorWiseSizeQuantityPairList.map((item) => {
					return {
						...item,
						sizeQuantityPairList: item.sizeQuantityPairList?.filter((obj) => obj.id !== sizeId)
					};
				});
				onSetOrderStyles(cloneStyles);
				setRemovedSizes([...removedSizes, sizeId]);
			}
			dispatch(closeLoader());
		} catch (e) {
			printApiError(e);
			dispatch(closeLoader());
		}
	};

	const onRemoveColor = async (itemId, item, quoteIndex) => {
		dispatch(openLoader());
		try {
			let cloneStyles = [...stylesData];
			if (item.colorWiseSizeQuantityPairList.length > 0) {
				cloneStyles[quoteIndex].colorWiseSizeQuantityPairList = await cloneStyles[
					quoteIndex
				].colorWiseSizeQuantityPairList?.filter((obj) => obj.id !== itemId);
				onSetOrderStyles(cloneStyles);
				setRemovedColorIds([...removedColorIds, itemId]);
			}
			dispatch(closeLoader());
		} catch (e) {
			printApiError(e);
			dispatch(closeLoader());
		}
	};

	const sortBySerial = (arrayList, sizeCategorySequence) => {
		if (arrayList) {
			let modifiedArrayList = arrayList.map((item) => {
				if ([item.sizeCategoryId] in sizeCategorySequence) {
					item.sizeCategorySerial = sizeCategorySequence[item.sizeCategoryId];
				}
				return item;
			});
			return modifiedArrayList.slice().sort((a, b) => {
				const serialA = a.sizeCategorySerial || Number.POSITIVE_INFINITY;
				const serialB = b.sizeCategorySerial || Number.POSITIVE_INFINITY;
				if (serialA !== serialB) {
					return serialA - serialB;
				}

				// If sizeCategorySerial is the same, compare by sizeCategoryId
				if (a.sizeCategoryId !== b.sizeCategoryId) {
					return a.sizeCategoryId - b.sizeCategoryId;
				}

				// If both sizeCategorySerial and sizeCategoryId are the same, compare by order
				return a.order - b.order;
			});
		}
	};

	const renderDesignTable = (item, quoteIndex) => {
		let tableHeadingBeforSort =
			item.colorWiseSizeQuantityPairList.length > 0
				? item.colorWiseSizeQuantityPairList[0]?.sizeQuantityPairList
				: item.sizeQuantityPairList;
		let tableHeading = sortBySerial(tableHeadingBeforSort, item.sizeCategorySequenceMap);
		return (
			<div
				className={
					item.colorWiseSizeQuantityPairList.length > 0
						? 'multiple-color-add-option'
						: 'multiple-color-add-option no-added-color'
				}
			>
				<div className="add-color-on-create-order" onClick={() => onAddColorModal(quoteIndex)}>
					{renderAddColor(item.productId, item.colorWiseSizeQuantityPairList)}
				</div>
				<div className={getTableClassName(quoteIndex)}>
					<table className={`table ${findHeadingMaxLength(item)}`}>
						<thead>
							<tr>
								<th></th>
								{tableHeading?.map((value) => (
									<th
										key={value.id}
										className={`${value.label.length > 7 ? 'large-heading' : ''}`}
									>
										<p className="semibold-14 col-heading">{value.label}</p>
										{isFromCreateOrder && (
											<span
												onClick={() => removeSizeColumn(item, value.id, quoteIndex)}
											>
												<img
													className="delete-button"
													src={`${process.env.PUBLIC_URL}/icons/delete24.svg`}
													alt="delete-image"
												/>
											</span>
										)}
									</th>
								))}

								<th onClick={() => onAddSizeModal(quoteIndex)}>
									<p className="semibold-14 col-heading cursor-pointer size-add custom-tooltip">
										<img src={`${process.env.PUBLIC_URL}/icons/plus-20.svg`} alt="plus" />
										<span className="tooltiptext">Add Size</span>
									</p>
								</th>

								{item.buyerQuotationType === 'COLORWISE' && (
									<th>
										<p className="semibold-14 col-heading">$</p>
									</th>
								)}
							</tr>
						</thead>
						<tbody>
							{item.colorWiseSizeQuantityPairList &&
								item.colorWiseSizeQuantityPairList?.map((value, index) => (
									<tr key={value.id}>
										<td>
											{value?.representedBy === 'SWATCH'
												? renderSwatchTypeColorsVertically(value)
												: renderPantoneTypeColorsVertically(value)}
											{isFromCreateOrder && (
												<span
													onClick={() => onRemoveColor(value.id, item, quoteIndex)}
												>
													<img
														className="delete-button"
														src={`${process.env.PUBLIC_URL}/icons/delete24.svg`}
														alt="delete-image"
													/>
												</span>
											)}
										</td>
										{value &&
											value.sizeQuantityPairList.map((style, inputIndex) => (
												<td key={style.id}>
													{/* <LoaderComponent loading={isUpdatingOrder}> */}
													<input
														readOnly={readOnly}
														type="number"
														autoComplete="off"
														name={style.label}
														value={style.quantity === 0 ? null : style.quantity}
														placeholder="00"
														onFocus={(event) =>
															(prevDataRef.current = event.target.value)
														}
														onChange={(e) =>
															onEditChange(e, index, quoteIndex, inputIndex)
														}
														disabled={isUpdatingOrder}
														min={1}
														onBlur={(e) => {
															if (!isValidInput(prevDataRef, e)) {
																prevDataRef.current = null;
																return;
															}
															onUpdateSizeColorWise(item, quoteIndex);
														}}
														onKeyPress={validateNumber}
													/>
												</td>
											))}
										<td>
											<input
												type="number"
												autoComplete="off"
												placeholder={'00'}
												value={getTotal(value.sizeQuantityPairList)}
												disabled
											/>
										</td>
										{item.buyerQuotationType === 'COLORWISE' && (
											<td>
												<input
													readOnly={readOnly}
													className={`${
														errorInfo.designId === item.id &&
														index == errorInfo.colorIndex
															? 'border-error'
															: ''
													}`}
													type="number"
													autoComplete="off"
													placeholder="$00"
													min={1}
													value={getColorWisePrice(
														item.colorWiseBuyerPrice,
														value.id
													)}
													onChange={(e) =>
														onChangeColorWise(e, quoteIndex, value.id)
													}
													onBlur={() =>
														onUpdateSizeColorWise(item, quoteIndex, true)
													}
													onKeyPress={validateFloatNumber}
												/>
											</td>
										)}
									</tr>
								))}
							{item.buyerQuotationType === 'SIZEWISE' && (
								<tr>
									<td></td>
									{item.colorWiseSizeQuantityPairList &&
										item.colorWiseSizeQuantityPairList[0]?.sizeQuantityPairList.map(
											(style) => (
												<td key={style.id}>
													<input
														readOnly={readOnly}
														className={`${
															errorInfo.designId === item.id &&
															style.id == errorInfo.sizeKey
																? 'border-error'
																: ''
														}`}
														type="number"
														autoComplete="off"
														min={1}
														placeholder="$00"
														value={getSizeWisePrice(
															item.sizeWiseBuyerPrice,
															style.id
														)}
														onChange={(e) =>
															onChangeSizeWise(e, quoteIndex, style.id)
														}
														onBlur={() =>
															onUpdateSizeColorWise(item, quoteIndex, true)
														}
														onKeyPress={validateFloatNumber}
													/>
												</td>
											)
										)}
								</tr>
							)}
						</tbody>
					</table>
					{isAddSize && addDesignIndex === quoteIndex && (
						<div ref={sizeRef}>{renderAddSize(item)}</div>
					)}
					{errorInfo.totalError && errorInfo.designId === item.id && (
						<span className="error">{errorInfo.totalError}</span>
					)}
					{item.buyerQuotationType === 'DESIGNWISE' && (
						<div className="total-units text-right">
							<span className="regular-14 gray_dark_02">
								Unit price:{' '}
								<input
									readOnly={readOnly}
									className={errorInfo.designWiseBuyerPriceError ? 'error-border' : ''}
									type="number"
									autoComplete="off"
									placeholder="$00"
									min={1}
									value={item.designWiseBuyerPrice}
									onChange={(e) => onChangeDesignWise(e, quoteIndex, item)}
									onKeyPress={validateFloatNumber}
									onFocus={(event) => (prevDataRef.current = event.target.value)}
									onBlur={(e) => {
										if (!isValidInput(prevDataRef, e)) {
											prevDataRef.current = null;
											return;
										}
										onUpdateSizeColorWise(item, quoteIndex, true);
									}}
								/>
							</span>
							{errorInfo.designWiseBuyerPriceError && errorInfo.designId === item.id && (
								<span className="error">{errorInfo.designWiseBuyerPriceError}</span>
							)}
						</div>
					)}
				</div>

				{isShowModal && (
					<SizeCategoryModal
						handleClose={() => setIsShowModal(false)}
						productId={item.productId}
						// sizeCategoryId={sizeCategoryId}
					/>
				)}
			</div>
		);
	};

	const onChangeDesignInfo = (e, quoteIndex) => {
		let { name, value } = e.target;
		const newData = [...stylesData];
		const orderData = newData[quoteIndex];
		orderData[name] = value;

		newData[quoteIndex] = orderData;
		onSetOrderStyles(newData);
	};

	const onSetEditIndex = (index) => {
		setEditableIndex(index);
	};

	const onUpdateDesignDetails = (data, index) => {
		let { deliveryDate, poNumber, referenceNumber, id, poReceiveDate } = data;
		let isValid = true;
		if (referenceNumber === '') {
			setEditableIndex(index);
			setErrorDesign({ designNoError: 'Design number is required', id, designIndex: index });
			isValid = false;
		}
		if (poNumber === '') {
			setEditableIndex(index);
			setErrorDesign({ poError: 'Po number is required', id, designIndex: index });
			isValid = false;
		}
		if (deliveryDate === '') {
			setEditableIndex(index);
			setErrorDesign({ etdError: 'Delivery date is required', id, designIndex: index });
			isValid = false;
		}
		if (poReceiveDate === '' || !poReceiveDate) {
			setEditableIndex(index);
			setErrorDesign({ poDateError: 'PO received date is required', id, designIndex: index });
			isValid = false;
		}
		if (!isValid) return;
		setErrorDesign({});
		setEditableIndex('');
		onUpdateDesignInfo(deliveryDate, poNumber, referenceNumber, id, poReceiveDate);
	};

	const onAddNewSize = () => {
		onClosePopups();
		setIsShowModal(true);
	};

	const filterStylesData = () => {
		if (hideStatusType) {
			return stylesData.filter((item) => {
				switch (hideStatusType) {
					case 'piCreated':
						return item.isPiCreated === true;
					case 'piPending':
						return item.isPiCreated === false;
					case 'scCreated':
						return item.isScCreated === true;
					case 'scPending':
						return item.isScCreated === false;
					case 'tnaCreated':
						return item.isTNACreated === true;
					case 'tnaPending':
						return item.isTNACreated === false;
					default:
						return true;
				}
			});
		} else {
			return stylesData;
		}
	};

	const openDesignViewModal = (item) => {
		dispatch(
			setDesignViewModalInfo({
				isShowMergeTechPack:
					item?.isSet || item?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT,
				id: item?.productId,
				onCloseViewModal: onCloseViewModal,
				source: 'PRODUCT_LIST',
				designIdList: designIdList
			})
		);
	};

	return (
		<>
			{filterStylesData()?.map((item, quoteIndex) => (
				<div
					className={`designs-row ${errorInfo.designId === item.id && 'error-box'} ${
						orderCancelInfo?.requestType === 'PRODUCT' &&
						orderCancelInfo?.status === 'REQUESTED' &&
						item.canceledStatus === 'REQUESTED'
							? 'highlight-row'
							: ''
					}`}
					key={item.id}
				>
					{/* Designwise quantity table */}

					<div className="single-design bg-white">
						{isShowStyleStatus && (
							<div className="pending-order-stepper on-design-info-item my-12">
								<ul className="d-flex">
									<li className={item.isPiCreated ? '' : 'disabled'}>
										<span className="step-count done">
											<img
												src={`${process.env.PUBLIC_URL}/icons/tick-green.png`}
												alt="tich"
											/>
										</span>
										PI
									</li>
									<li className={item.isScCreated ? '' : 'disabled'}>
										<span className="step-count done">
											<img
												src={`${process.env.PUBLIC_URL}/icons/tick-green.png`}
												alt="tich"
											/>
										</span>
										Sales contact
									</li>
									<li className={item.isTNACreated ? '' : 'disabled'}>
										<span className="step-count done">
											<img
												src={`${process.env.PUBLIC_URL}/icons/tick-green.png`}
												alt="tich"
											/>
										</span>
										TNA
									</li>
								</ul>
							</div>
						)}
						<div className="d-flex">
							<div
								className="design-image"
								data-toggle="modal"
								data-target="#designViewModal"
								onClick={() => openDesignViewModal(item)}
							>
								{item?.isSet ? (
									renderSetImages(item?.documentResponseList, '184px')
								) : (
									<img src={item?.documentResponseList[0]?.docUrl} alt={item.name} />
								)}

								{isFromCreateOrder && (
									<span
										onClick={(e) => {
											e.stopPropagation();
											removeStyle(item.productId);
										}}
									>
										<img
											className="delete-button"
											src={`${process.env.PUBLIC_URL}/icons/delete_gray.svg`}
											alt="delete-image"
										/>
									</span>
								)}

								{!isFromCreateOrder &&
									!readOnly &&
									(orderDetailsInfo?.status === 'PENDING' ||
										orderDetailsInfo?.status === 'RUNNING') && (
										<div className="custom-chekbox" onClick={(e) => e.stopPropagation()}>
											<div className="form-group m-0">
												<input
													key={item.id}
													type="checkbox"
													id={`design_${item.id}`}
													checked={selectedRFQIds.includes(item.id)}
													onChange={() => handleRFQIds(item.id)}
												/>
												<label htmlFor={`design_${item.id}`} />
											</div>
										</div>
									)}
							</div>

							<div className="design-details-info">
								<div className="design-title d-flex justify-content-between">
									<div>
										<div className="mb-1">
											{' '}
											{item?.isSet && setTag()} {item?.isPack && packTag()}
										</div>
										<h3 className="regular-14 gray_dark_02 mb-0">
											<Tooltip title={item.name} placement="top" arrow>
												<span
													data-toggle="modal"
													data-target="#designViewModal"
													onClick={() => openDesignViewModal(item)}
												>
													{item.name}
												</span>
											</Tooltip>
										</h3>
										{isDesignEditable && editableIndex === quoteIndex ? (
											''
										) : (
											<p className="semibold-14 gray_dark_01 mb-2">
												{' '}
												{!item?.isSet && `${item.referenceNumber}`}
											</p>
										)}
									</div>
									{isDesignEditable && (
										<div className="buttons">
											{editableIndex === quoteIndex ? (
												<>
													<span
														className="regular-14 primary_bright_01 cursor-pointer"
														onClick={() =>
															onUpdateDesignDetails(item, editableIndex)
														}
													>
														Update
													</span>
													<span
														className="regular-14 red ml-2 cursor-pointer"
														onClick={() => onSetEditIndex('')}
													>
														Cancel
													</span>{' '}
												</>
											) : (
												<span
													className="regular-14 primary_bright_01 ml-2 cursor-pointer"
													onClick={() => onSetEditIndex(quoteIndex)}
												>
													Edit
												</span>
											)}
										</div>
									)}
								</div>
								{quoteIndex === editableIndex || !isDesignEditable ? (
									<div className="po-details">
										<div className="container px-0">
											<div className="row">
												<div className="col-md-6 pr-1">
													<div className="form-group mb-0">
														<label htmlFor="design-no">Design No</label>
														<input
															readOnly={readOnly}
															type="text"
															autoComplete="off"
															name="referenceNumber"
															placeholder="125/ASK/21-24/125"
															value={item['referenceNumber']}
															onChange={(e) =>
																onChangeDesignInfo(e, quoteIndex)
															}
														/>
														{errorDesign.designNoError &&
															errorDesign.id === item.id && (
																<span className="error">
																	{errorDesign.designNoError}
																</span>
															)}

														{errorInfo?.designNoError &&
															errorInfo?.designId === item.id && (
																<span className="error">
																	{errorInfo?.designNoError}
																</span>
															)}
													</div>
												</div>
												<div className="col-md-6 pr-1">
													<div className="form-group mb-0">
														<label htmlFor="po-no">PO No</label>
														<input
															readOnly={readOnly}
															type="text"
															autoComplete="off"
															placeholder="PO/45/KM/2021"
															value={item['poNumber']}
															onChange={(e) =>
																onChangeDesignInfo(e, quoteIndex)
															}
															name="poNumber"
														/>
														{errorDesign.poError &&
															errorDesign.id === item.id && (
																<span className="error">
																	{errorDesign.poError}
																</span>
															)}
														{errorInfo?.poError &&
															errorInfo?.designId === item.id && (
																<span className="error">
																	{errorInfo?.poError}
																</span>
															)}
													</div>
												</div>
												<div className="col-md-12 mt-1">
													<div className="form-group mb-0">
														<label htmlFor="etd">ETD (mm/dd/yyyy)</label>
														<input
															readOnly={readOnly}
															type="date"
															id="date"
															// value={changeDateFormat(
															// 	item['deliveryDate'],
															// 	'',
															// 	'YYYY-MM-DD'
															// )}
															value={item['deliveryDate']}
															onChange={(e) =>
																onChangeDesignInfo(e, quoteIndex)
															}
															name="deliveryDate"
														/>
														{errorDesign.etdError &&
															errorDesign.id === item.id && (
																<span className="error">
																	{errorDesign.etdError}
																</span>
															)}
														{errorInfo?.etdError &&
															errorInfo?.designId === item.id && (
																<span className="error">
																	{errorInfo?.etdError}
																</span>
															)}
													</div>
												</div>

												<div className="col-md-12 mt-1">
													<div className="form-group mb-0">
														<label htmlFor="poReceiveDate">
															PO received date
														</label>
														<input
															readOnly={readOnly}
															type="date"
															id="poReceiveDate"
															value={item['poReceiveDate']}
															onChange={(e) =>
																onChangeDesignInfo(e, quoteIndex)
															}
															name="poReceiveDate"
														/>
														{errorDesign.poDateError &&
															errorDesign.id === item.id && (
																<span className="error">
																	{errorDesign.poDateError}
																</span>
															)}
														{errorInfo?.poDateError &&
															errorInfo?.designId === item.id && (
																<span className="error">
																	{errorInfo?.poDateError}
																</span>
															)}
													</div>
												</div>

												{isFromCreateOrder && (
													<div className="values d-flex">
														<div className="total-value pl-3 mt-3 pr-3">
															<span className="regular-14 gray_dark_02">
																Total Qty:{' '}
															</span>
															<span className="semibold-14">
																{onGetDesignWiseToalQuantity(
																	item.id,
																	item.buyerQuotationType
																)}
															</span>
														</div>

														<div className="total-value pl-0 mt-3">
															<span className="regular-14 gray_dark_02">
																Price:{' '}
															</span>
															<span className="semibold-14">
																$
																{onGetDesignWiseToalPrice(
																	item.id,
																	item.buyerQuotationType
																)}
															</span>
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								) : (
									<div className="po-details-view">
										<div className="po-info-colums-view">
											<ul>
												<li>PO: {item.poNumber}</li>
												<li>ETD: {item.deliveryDate}</li>
											</ul>
											<ul className="pt-1">
												<li>PO received date: {item?.poReceiveDate}</li>
											</ul>
										</div>

										<div className="po-quantity-colums-view">
											<ul>
												<li>
													<span>{item?.colorWiseSizeQuantityPairList?.length}</span>{' '}
													colors
												</li>
												<li>
													<span>
														{
															item?.colorWiseSizeQuantityPairList[0]
																?.sizeQuantityPairList?.length
														}
													</span>{' '}
													size
												</li>
											</ul>
											<div className="values-row d-flex">
												<div className="total-value">
													<span className="regular-14 gray_dark_02">
														Total Qty:
													</span>
													{item?.quantity && (
														<span className="semibold-14"> {item.quantity}</span>
													)}
												</div>
												<div className="total-value ml-2">
													<span className="regular-14 gray_dark_02">Price:</span>
													{item?.amount && (
														<span className="semibold-14">
															{' '}
															${convertNumberToUSFormat(item.amount)}
														</span>
													)}
												</div>
											</div>
											<p className="regular-14 gray_dark_01">{item?.supplierName}</p>
										</div>
									</div>
								)}

								{orderCancelInfo?.status === 'REQUESTED' &&
									orderCancelInfo?.requestType === 'PRODUCT' &&
									item.canceledStatus === 'REQUESTED' && (
										<span
											className="status cancelTag d-inline-block mt-4
									"
										>
											Style cancel
										</span>
									)}
							</div>

							<div className="design-quantity-table">
								<div className="design-info-dropdowns">
									<div className="dropdows-row d-flex justify-content-end mb-1">
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
													disabled={readOnly}
												>
													{item?.buyerQuotationType
														? parseQuoteName(item.buyerQuotationType)
														: 'Quote type'}
													<img
														src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
														alt="down"
														className="ml-2"
													/>
												</button>
												<ul className="dropdown-menu dropdown-menu-right shadow-4dp">
													{allQuotation &&
														allQuotation?.quotationType?.map((item, idx) => (
															<li className="px-4 pb-3 pt-3" key={idx}>
																<a
																	href={void 0}
																	className="gray_dark_02"
																	onClick={() =>
																		onChangeQuotationType(
																			item,
																			quoteIndex
																		)
																	}
																	onBlur={() =>
																		onUpdateSizeColorWise(
																			item,
																			quoteIndex
																		)
																	}
																>
																	{item.name}
																</a>
															</li>
														))}
												</ul>
											</div>
										</div>
										<div className="option">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle gray_dark_02 regular-14"
													type="button"
													data-toggle="dropdown"
													aria-expanded="false"
													disabled={readOnly}
												>
													{item?.priceType}

													<img
														src={`${process.env.PUBLIC_URL}/icons/down-arrow.png`}
														alt="down"
														className="ml-2"
													/>
												</button>

												<ul className="dropdown-menu dropdown-menu-right shadow-4db">
													<li className="px-4 pb-3 pt-3">
														<a
															href={void 0}
															className="gray_dark_02"
															onClick={() => {
																onChangePriceType('CIF', quoteIndex);
																// onUpdateColorSize(item, quoteIndex);
															}}
														>
															CIF
														</a>
													</li>
													<li className="px-4 pb-3 pt-3">
														<a
															href={void 0}
															className="gray_dark_02"
															onClick={() => {
																onChangePriceType('FOB', quoteIndex);
																// onUpdateColorSize(item, quoteIndex);
															}}
														>
															FOB
														</a>
													</li>
												</ul>
											</div>
											{errorInfo.priceTypeError && errorInfo.designId === item.id && (
												<span className="error">{errorInfo.priceTypeError}</span>
											)}
										</div>
									</div>
								</div>
								<div className="design-table">{renderDesignTable(item, quoteIndex)}</div>
							</div>
						</div>
					</div>
				</div>
			))}
			<OrderCancelBottomBar selectedRFQIds={selectedRFQIds} setSelectedRFQIds={setSelectedRFQIds} />
		</>
	);
};

export default OrderStyleItem;
